import { styled } from '@mui/material'
import Dialog from '@mui/material/Dialog'

const computeWidth = (theme) => {
	if (theme.breakpoints.up('lg')) return '580px!important'
	if (theme.breakpoints.up('md')) return '473px!important'
	return '341px!important'
}

export const StyledDialog = styled(Dialog)(({ theme }) => ({
	margin: 'auto',
	maxWidth: computeWidth(theme),
	'& .MuiPaper-root': {
		padding: { xs: '2rem', md: '3rem' }
	}
}))
